import { PIN_LAYOUTS, PIN_STANDARD } from 'constants-content';
import { Primitive } from 'lane-shared/types/blocks/Primitive';
import { IntegrationProviderEnum } from 'constants-integrations';

const ShopifyMultipassSectionBlock: Primitive = {
  name: 'ShopifyMultipassSectionBlock',
  friendlyName: 'Shopify Multipass Section Block',
  isAvailableInEditor: true,
  isInput: false,
  isPrimitive: true,
  tags: ['Content'],
  dependencies: {
    channelIntegrations: [IntegrationProviderEnum.ShopifyMultipass],
    isSuperUser: true,
  },
  properties: {
    channelIntegration: {
      type: 'ChannelIntegration',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    header: {
      friendlyName: 'Header',
      type: 'String',
      validators: [
        {
          name: 'Max',
          value: 80,
        },
      ],
    },
    section: {
      type: 'Content Channel',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    listView: {
      friendlyName: 'Pin View',
      type: 'String',
      default: PIN_STANDARD,
      validators: [
        {
          name: 'In',
          value: PIN_LAYOUTS,
        },
      ],
    },
    showFilters: {
      friendlyName: 'Show Search & Filtering',
      description:
        'Show search and filtering for this content (if it has been enabled on the content)',
      default: false,
      type: 'Boolean',
    },
    flexDirection: {
      type: 'FlexDirection',
      friendlyName: 'Layout',
    },
    perPage: {
      type: 'Number',
      friendlyName: 'Items per page',
      default: 5,
      validators: [
        {
          name: 'Min',
          value: 5,
        },
        {
          name: 'Max',
          value: 15,
        },
      ],
    },
    autoHide: {
      type: 'Boolean',
      friendlyName: 'Hide when no results',
      default: false,
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};

export default ShopifyMultipassSectionBlock;
